import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SiteSettingsContext } from '@namespace/cms';
import {
  getAvailableLanguageFromPath,
  updateUrlLang,
  useI18nStore
} from '@namespace/i18n';

export const useSyncLangUrlStore = () => {
  const { language, isTranslationsInitialized } = useI18nStore([
    'language',
    'isTranslationsInitialized'
  ]);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [settings] = useContext(SiteSettingsContext);
  const { siteConfig = {}, otherSettings = {} } = settings || {};
  const { languages = [] } = siteConfig;
  const { hiddenLanguageInUrl } = otherSettings;
  const urlLangRaw = getAvailableLanguageFromPath(pathname, languages);
  const urlLang = urlLangRaw ?? hiddenLanguageInUrl;

  useEffect(() => {
    if (!isTranslationsInitialized) {
      return;
    }

    if (urlLang && language && urlLang !== language) {
      const newLocation = updateUrlLang(
        window.location,
        language,
        hiddenLanguageInUrl
      );
      navigate(newLocation, { replace: true });
    }
  }, [
    hiddenLanguageInUrl,
    urlLang,
    navigate,
    language,
    isTranslationsInitialized
  ]);
};
